export const SET_QUERY_INPUTTED_FOR_FILTER_BUTTON =
  'SET_QUERY_INPUTTED_FOR_FILTER_BUTTON';
export const SET_FIRST_VISIBLE_PARA = 'SET_FIRST_VISIBLE_PARA';
